import React, {Dispatch, SetStateAction} from 'react';
import Theme from '../../../styles/models/theme';
import {InputField, InputContainer, InputLabel, HelperText} from './styles';

interface InputProps {
  type: string;
  placeholder: string;
  label?: string;
  theme: Theme;
  value: any;
  onChange: Dispatch<SetStateAction<any>>;
  helperText?: string;
  helperValue?: string;
  disabled?: boolean;
}

const Input: React.FC<InputProps> = ({
  type,
  placeholder,
  label,
  theme,
  onChange,
  value,
  helperText = '',
  disabled = false,
}) => {
  return (
    <InputContainer>
      <InputLabel theme={theme}>{label}</InputLabel>
      <InputField
        type={type}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        theme={theme}
        disabled={disabled}
        defaultValue={value}
      />
      <HelperText theme={theme}>{helperText}</HelperText>
    </InputContainer>
  );
};

export default Input;
